
(function () {
  /* ── Helpers ──────────────────────────────────────────────────────── */
  function formatMoney(cents) {
    return theme.Currency.formatMoney(cents, theme.moneyFormat);
  }
  // Shopify JSON returns featured_image as a string OR an object with .src.
  function imgUrl(raw, width) {
    if (!raw) return '';
    var src = typeof raw === 'object' ? raw.src || '' : raw;
    if (!src) return '';
    return src + (src.indexOf('?') !== -1 ? '&' : '?') + 'width=' + width;
  }
  // Escape user-supplied strings before injecting into innerHTML.
  function esc(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  /* ── Pre-fetch cache (set on ATC click, consumed in load()) ─────── */
  var prefetchCache = { productId: null, promise: null };
  /* ── Products cache — stores full product objects for quick-view ─── */
  var productsCache = {};
  /* ── Fetch recs: fires complementary + related in parallel ────────── */
  function fetchRecs(productId, limit, intent) {
    var intents = intent === 'related' ? ['related'] : ['complementary', 'related'];
    return Promise.all(
      intents.map(function (it) {
        return fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit + '&intent=' + it)
          .then(function (r) {
            return r.json();
          })
          .then(function (d) {
            return d.products && d.products.length ? d.products : [];
          })
          .catch(function () {
            return [];
          });
      })
    ).then(function (results) {
      // Prefer complementary; fall back to related
      return results[0] && results[0].length ? results[0] : results[1] || [];
    });
  }
  /* ── Intercept ATC click → pre-fetch before drawer even opens ─────── */
  // Runs in capture phase so it fires immediately, before Impulse's handler.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;
      var form = btn.closest('form');
      if (!form) return;
      var pidInput = form.querySelector('input[name="product-id"]');
      if (!pidInput) return;
      var productId = parseInt(pidInput.value, 10);
      if (!productId) return;
      var root = document.getElementById('cart-recs-slider');
      var limit = root ? parseInt(root.dataset.limit, 10) || 5 : 5;
      var intent = root ? root.dataset.intent || 'complementary' : 'complementary';
      // Fire recommendations fetch immediately — in parallel, right now.
      prefetchCache.productId = productId;
      prefetchCache.promise = fetchRecs(productId, limit, intent);
    },
    true
  );
  /* ── Card builder ─────────────────────────────────────────────────── */
  function buildCard(product) {
    var isOnSale = product.compare_at_price && product.compare_at_price > product.price;
    var src = imgUrl(product.featured_image, 320);
    var variantId = product.variants && product.variants[0] ? product.variants[0].id : null;
    var variantCount = product.variants ? product.variants.length : 0;
    var imgHtml = src
      ? '<img src="' + esc(src) + '" alt="" role="presentation" loading="lazy" width="80" height="110">'
      : '';
    var compareHtml = isOnSale
      ? '<span class="crs__compare-price">' + formatMoney(product.compare_at_price) + '</span>'
      : '';
    // Store full product object so quick-view modal can access all variant data
    productsCache[String(product.id)] = product;
    var atcBtnHtml = variantId
      ? '<button type="button" class="crs__action-btn crs__atc-btn"' +
        ' data-variant-id="' + esc(String(variantId)) + '"' +
        ' data-variant-count="' + variantCount + '"' +
        ' data-product-id="' + esc(String(product.id)) + '">Aggiungi al carrello</button>'
      : '';
    var card = document.createElement('div');
    card.className = 'crs__card' + (isOnSale ? ' is-on-sale' : '');
    card.setAttribute('role', 'listitem');
    card.innerHTML =
      '<a class="crs__card-img-link" href="' + esc(product.url) + '">' +
      '<div class="crs__card-img-wrap">' + imgHtml + '</div>' +
      '</a>' +
      '<div class="crs__card-info">' +
      '<a class="crs__card-title-link" href="' + esc(product.url) + '">' +
      '<p class="crs__card-title">' + esc(product.title) + '</p>' +
      '</a>' +
      '<div class="crs__price-list">' +
      compareHtml +
      '<span class="crs__sale-price">' + formatMoney(product.price) + '</span>' +
      '</div>' +
      atcBtnHtml +
      '</div>';
    return card;
  }
  /* ── Self-contained quick-view modal ─────────────────────────────── */
  var crsModalEl = null;
  var crsSelOpts = [];
  var crsGalleryImages = [];
  var crsGalleryImageIds = []; // parallel array: Shopify image IDs for reliable variant-image matching
  var crsGalleryCurrent = 0;
  var crsRenderFn = null; // set by CartRecsSlider so modal ATC can update the slider directly
  function crsModalBuild() {
    if (crsModalEl) return crsModalEl;
    var el = document.createElement('div');
    el.id = 'crs-modal-overlay';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Quick view');
    el.innerHTML =
      '<div class="crs-modal">' +
      '<button type="button" class="crs-modal__close" aria-label="Close">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
      '<path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"/></svg>' +
      '</button>' +
      '<div class="crs-modal__inner">' +
      '<div class="crs-modal__gallery">' +
      '<div class="crs-modal__gallery-viewport">' +
      '<div class="crs-modal__gallery-track" id="crs-modal-track"></div>' +
      '</div>' +
      '<button type="button" class="crs-modal__gallery-arrow crs-modal__gallery-arrow--prev" id="crs-modal-prev" aria-label="Previous image">' +
      '<svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M7 1 1 7l6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/></svg>' +
      '</button>' +
      '<button type="button" class="crs-modal__gallery-arrow crs-modal__gallery-arrow--next" id="crs-modal-next" aria-label="Next image">' +
      '<svg width="8" height="14" viewBox="0 0 8 14" fill="none"><path d="M1 1l6 6-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="square"/></svg>' +
      '</button>' +
      '<div class="crs-modal__gallery-dots" id="crs-modal-dots"></div>' +
      '</div>' +
      '<div class="crs-modal__info">' +
      '<h2 class="crs-modal__title" id="crs-modal-title"></h2>' +
      '<div class="crs-modal__price-row" id="crs-modal-price"></div>' +
      '<div class="crs-modal__options" id="crs-modal-options"></div>' +
      '<button type="button" class="crs-modal__atc-btn" id="crs-modal-atc">Aggiungi al carrello</button>' +
      '<a class="crs-modal__view-more" id="crs-modal-view-more" href="#">View details</a>' +
      '</div></div></div>';
    el.querySelector('.crs-modal__close').addEventListener('click', function (e) {
      e.stopPropagation();
      crsModalClose();
    });
    // stopPropagation prevents the click reaching the theme's "click outside drawer" handler
    el.addEventListener('click', function (e) {
      e.stopPropagation();
      if (e.target === el) crsModalClose();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('is-open')) {
        e.stopPropagation();
        crsModalClose();
      }
    }, true); // capture phase so we run before the theme's bubble-phase handler
    document.body.appendChild(el);
    /* Mobile: swipe left/right to navigate the gallery */
    var galleryVp = el.querySelector('.crs-modal__gallery-viewport');
    var modalTouchStartX = 0;
    galleryVp.addEventListener('touchstart', function (e) {
      modalTouchStartX = e.touches[0].clientX;
    }, { passive: true });
    galleryVp.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - modalTouchStartX;
      if (Math.abs(dx) < 40) return;
      crsGalleryGoTo(dx < 0 ? crsGalleryCurrent + 1 : crsGalleryCurrent - 1);
    }, { passive: true });
    crsModalEl = el;
    return el;
  }
  function crsGalleryRender(title) {
    var track = crsModalEl.querySelector('#crs-modal-track');
    var dotsEl = crsModalEl.querySelector('#crs-modal-dots');
    var prevBtn = crsModalEl.querySelector('#crs-modal-prev');
    var nextBtn = crsModalEl.querySelector('#crs-modal-next');
    track.innerHTML = '';
    dotsEl.innerHTML = '';
    crsGalleryImages.forEach(function (src, i) {
      var slide = document.createElement('div');
      slide.className = 'crs-modal__gallery-slide';
      var img = document.createElement('img');
      img.src = src + (src.indexOf('?') !== -1 ? '&' : '?') + 'width=800';
      img.alt = i === 0 ? title : '';
      img.loading = i === 0 ? 'eager' : 'lazy';
      slide.appendChild(img);
      track.appendChild(slide);
      if (crsGalleryImages.length > 1) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'crs-modal__gallery-dot';
        dot.setAttribute('aria-label', 'Image ' + (i + 1));
        (function (idx) {
          dot.addEventListener('click', function (e) { e.stopPropagation(); crsGalleryGoTo(idx); });
        })(i);
        dotsEl.appendChild(dot);
      }
    });
    prevBtn.onclick = function (e) { e.stopPropagation(); crsGalleryGoTo(crsGalleryCurrent - 1); };
    nextBtn.onclick = function (e) { e.stopPropagation(); crsGalleryGoTo(crsGalleryCurrent + 1); };
    var showNav = crsGalleryImages.length > 1;
    prevBtn.style.display = showNav ? '' : 'none';
    nextBtn.style.display = showNav ? '' : 'none';
    dotsEl.style.display = showNav ? '' : 'none';
    crsGalleryGoTo(0);
  }
  function crsGalleryGoTo(idx) {
    var total = crsGalleryImages.length;
    if (!crsModalEl || idx < 0 || idx >= total) return;
    crsGalleryCurrent = idx;
    var track = crsModalEl.querySelector('#crs-modal-track');
    track.style.transform = 'translateX(-' + (idx * 100) + '%)';
    crsModalEl.querySelectorAll('.crs-modal__gallery-dot').forEach(function (d, i) {
      d.classList.toggle('is-active', i === idx);
    });
    crsModalEl.querySelector('#crs-modal-prev').disabled = idx === 0;
    crsModalEl.querySelector('#crs-modal-next').disabled = idx === total - 1;
  }
  function crsModalOpen(product) {
    var el = crsModalBuild();
    el.querySelector('#crs-modal-title').textContent = product.title || '';
    el.querySelector('#crs-modal-view-more').href = product.url || '#';
    // Collect all product images for the gallery slider
    crsGalleryImages = [];
    crsGalleryImageIds = [];
    if (product.images && product.images.length) {
      product.images.forEach(function (img) {
        var s = typeof img === 'object' ? (img.src || '') : String(img);
        var id = typeof img === 'object' ? (img.id || null) : null;
        if (s) { crsGalleryImages.push(s); crsGalleryImageIds.push(id); }
      });
    } else {
      var imgSeen = {};
      if (product.featured_image) {
        var fs = typeof product.featured_image === 'object'
          ? (product.featured_image.src || '') : product.featured_image;
        var fid = typeof product.featured_image === 'object' ? (product.featured_image.id || null) : null;
        if (fs) { imgSeen[fs] = true; crsGalleryImages.push(fs); crsGalleryImageIds.push(fid); }
      }
      (product.variants || []).forEach(function (v) {
        if (v.featured_image) {
          var vs = typeof v.featured_image === 'object'
            ? (v.featured_image.src || '') : v.featured_image;
          var vid = typeof v.featured_image === 'object' ? (v.featured_image.id || null) : null;
          if (vs && !imgSeen[vs]) { imgSeen[vs] = true; crsGalleryImages.push(vs); crsGalleryImageIds.push(vid); }
        }
      });
    }
    crsGalleryCurrent = 0;
    crsGalleryRender(product.title || '');
    crsSelOpts = [];
    var optionsEl = el.querySelector('#crs-modal-options');
    optionsEl.innerHTML = '';
    var firstOpt = product.options && product.options[0];
    var hasOpts = product.options && product.options.length > 0 &&
      !(product.options.length === 1 &&
        (firstOpt === 'Title' || (typeof firstOpt === 'object' && firstOpt.name === 'Title')));
    if (hasOpts) {
      product.options.forEach(function (opt, optIdx) {
        var optName = typeof opt === 'object' ? (opt.name || '') : opt;
        var seen = {};
        var values = [];
        product.variants.forEach(function (v) {
          var val = v['option' + (optIdx + 1)];
          if (val && !seen[val]) { seen[val] = true; values.push(val); }
        });
        crsSelOpts[optIdx] = values[0];
        var group = document.createElement('div');
        group.className = 'crs-modal__option-group';
        var lbl = document.createElement('p');
        lbl.className = 'crs-modal__option-label';
        lbl.textContent = optName + ':';
        var wrap = document.createElement('div');
        wrap.className = 'crs-modal__swatches';
        values.forEach(function (val, vi) {
          var sb = document.createElement('button');
          sb.type = 'button';
          /* For colour-type options, find the matching variant image */
          var isColorOpt = /colou?r/i.test(optName);
          var swatchImgSrc = '';
          if (isColorOpt) {
            for (var vIdx = 0; vIdx < product.variants.length; vIdx++) {
              var tv = product.variants[vIdx];
              if (tv['option' + (optIdx + 1)] === val && tv.featured_image) {
                var rawFI = typeof tv.featured_image === 'object'
                  ? (tv.featured_image.src || '') : tv.featured_image;
                if (rawFI) { swatchImgSrc = rawFI; break; }
              }
            }
          }
          if (swatchImgSrc) {
            var thumbSrc = swatchImgSrc + (swatchImgSrc.indexOf('?') !== -1 ? '&' : '?') + 'width=88';
            sb.className = 'crs-modal__swatch has-img' + (vi === 0 ? ' is-selected' : '');
            sb.style.backgroundImage = 'url(' + thumbSrc + ')';
            sb.setAttribute('title', val);
            var srSpan = document.createElement('span');
            srSpan.className = 'crs-swatch-sr';
            srSpan.textContent = val;
            sb.appendChild(srSpan);
          } else {
            sb.className = 'crs-modal__swatch' + (vi === 0 ? ' is-selected' : '');
            sb.textContent = val;
          }
          sb.addEventListener('click', function () {
            wrap.querySelectorAll('.crs-modal__swatch').forEach(function (s) { s.classList.remove('is-selected'); });
            sb.classList.add('is-selected');
            crsSelOpts[optIdx] = val;
            crsModalUpdateVariant(product);
          });
          wrap.appendChild(sb);
        });
        group.appendChild(lbl);
        group.appendChild(wrap);
        optionsEl.appendChild(group);
      });
    }
    crsModalUpdateVariant(product);
    var atcBtn = el.querySelector('#crs-modal-atc');
    atcBtn.disabled = false;
    atcBtn.textContent = 'Aggiungi al carrello';
    atcBtn.onclick = function () {
      var variant = crsFindVariant(product, crsSelOpts);
      if (!variant || !variant.available) return;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding\u2026';
      // Pre-fetch recs for the newly added product while the ATC request is in flight
      var root = document.getElementById('cart-recs-slider');
      var rLimit = root ? parseInt(root.dataset.limit, 10) || 5 : 5;
      var rIntent = root ? root.dataset.intent || 'complementary' : 'complementary';
      prefetchCache.productId = product.id;
      prefetchCache.promise = fetchRecs(product.id, rLimit, rIntent);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) throw new Error(data.description || 'Error');
          atcBtn.textContent = 'Added!';
          document.dispatchEvent(new CustomEvent('cart:build'));
          // Directly update the upsell slider — prefetch is already in flight
          prefetchCache.promise
            .then(function (products) {
              if (crsRenderFn && products && products.length) crsRenderFn(products);
            })
            .catch(function () {});
          setTimeout(crsModalClose, 900);
        })
        .catch(function () {
          atcBtn.textContent = 'Error — try again';
          atcBtn.disabled = false;
        });
    };
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    el.querySelector('.crs-modal').focus();
  }
  function crsModalClose() {
    if (!crsModalEl) return;
    crsModalEl.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function crsFindVariant(product, selected) {
    if (!product.variants) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var ok = true;
      for (var j = 0; j < selected.length; j++) {
        if (v['option' + (j + 1)] !== selected[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }
  function crsModalUpdateVariant(product) {
    if (!crsModalEl) return;
    var variant = crsFindVariant(product, crsSelOpts);
    var atcBtn = crsModalEl.querySelector('#crs-modal-atc');
    var priceEl = crsModalEl.querySelector('#crs-modal-price');
    if (!variant) { atcBtn.textContent = 'Unavailable'; atcBtn.disabled = true; return; }
    atcBtn.disabled = !variant.available;
    atcBtn.textContent = variant.available ? 'Aggiungi al carrello' : 'Esaurito';
    var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
    priceEl.innerHTML =
      '<span class="crs-modal__sale-price' + (sale ? ' is-on-sale' : '') + '">' +
      formatMoney(variant.price) + '</span>' +
      (sale ? '<span class="crs-modal__compare-price">' + formatMoney(variant.compare_at_price) + '</span>' : '');
    // Jump gallery to the variant's image when selection changes
    if (variant.featured_image && crsGalleryImages.length > 0) {
      var varImgId = typeof variant.featured_image === 'object' ? (variant.featured_image.id || null) : null;
      var varSrc = typeof variant.featured_image === 'object'
        ? (variant.featured_image.src || '') : String(variant.featured_image || '');
      var varBase = varSrc ? varSrc.replace(/^https?:/, '').split('?')[0] : '';
      var targetIdx = -1;
      // 1st pass: match by image ID (most reliable)
      if (varImgId) {
        for (var gi = 0; gi < crsGalleryImageIds.length; gi++) {
          if (crsGalleryImageIds[gi] === varImgId) { targetIdx = gi; break; }
        }
      }
      // 2nd pass: match by URL base, stripping protocol so http/https/protocol-relative all match
      if (targetIdx === -1 && varBase) {
        for (var gi2 = 0; gi2 < crsGalleryImages.length; gi2++) {
          var imgBase = crsGalleryImages[gi2].replace(/^https?:/, '').split('?')[0];
          if (imgBase === varBase) { targetIdx = gi2; break; }
        }
      }
      if (targetIdx !== -1) crsGalleryGoTo(targetIdx);
    }
  }
  /* ── Slider initialisation ────────────────────────────────────────── */
  function CartRecsSlider() {
    var root = document.getElementById('cart-recs-slider');
    if (!root) return;
    var track = root.querySelector('.crs__track');
    var dotsWrap = root.querySelector('.crs__dots');
    var limit = parseInt(root.dataset.limit, 10) || 5;
    var intent = root.dataset.intent || 'complementary';
    var current = 0;
    var total = 0;
    var startX = 0;
    var lastProductId = null; // track first-item ID to avoid redundant fetches
    /* Slide to a specific index */
    function goTo(index) {
      if (index < 0 || index >= total) return;
      current = index;
      // Each card is min-width:100%; gap between cards is 12 px.
      track.style.transform = 'translateX(calc(' + -current * 100 + '% - ' + current * 12 + 'px))';
      dotsWrap.querySelectorAll('.crs__dot').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
    }
    /* Build clickable dot buttons */
    function buildDots(count) {
      dotsWrap.innerHTML = '';
      for (var i = 0; i < count; i++) {
        (function (idx) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'crs__dot' + (idx === 0 ? ' is-active' : '');
          btn.setAttribute('role', 'tab');
          btn.setAttribute('aria-label', 'Go to slide ' + (idx + 1));
          btn.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
          btn.addEventListener('click', function () {
            goTo(idx);
          });
          dotsWrap.appendChild(btn);
        })(i);
      }
    }
    /* Populate track with product cards */
    function render(products) {
      crsRenderFn = render; // expose to outer scope for modal ATC
      track.innerHTML = '';
      dotsWrap.innerHTML = '';
      products.forEach(function (p) {
        track.appendChild(buildCard(p));
      });
      total = products.length;
      current = 0;
      buildDots(total);
      goTo(0);
      root.style.display = '';
    }
    /* Touch / swipe support */
    root.addEventListener(
      'touchstart',
      function (e) {
        startX = e.touches[0].clientX;
      },
      { passive: true }
    );
    root.addEventListener(
      'touchend',
      function (e) {
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) < 40) return;
        goTo(dx < 0 ? current + 1 : current - 1);
      },
      { passive: true }
    );
    /* ── Add-to-cart handler ──────────────────────────────────────────── */
    function handleAtcClick(btn) {
      var variantCount = parseInt(btn.dataset.variantCount, 10) || 1;
      // Multiple variants → open the self-contained quick-view modal
      if (variantCount > 1) {
        var prod = productsCache[btn.dataset.productId];
        if (prod) { crsModalOpen(prod); }
        return;
      }
      var variantId = parseInt(btn.dataset.variantId, 10);
      if (!variantId) return;
      var origText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding\u2026';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status && data.status !== 200) throw new Error(data.description || 'Error');
          btn.textContent = 'Added!';
          document.dispatchEvent(new CustomEvent('cart:build'));
          // Pre-fetch recs for the newly added product and update the slider
          var productId = parseInt(btn.dataset.productId, 10);
          if (productId) {
            prefetchCache.productId = productId;
            prefetchCache.promise = fetchRecs(productId, limit, intent);
            prefetchCache.promise
              .then(function (products) {
                if (crsRenderFn && products && products.length) crsRenderFn(products);
              })
              .catch(function () {});
          }
          setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 2000);
        })
        .catch(function () {
          btn.textContent = 'Error';
          setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 2000);
        });
    }
    /* ── Delegate clicks for card action buttons ──────────────────────── */
    root.addEventListener('click', function (e) {
      var atcBtn = e.target.closest('.crs__atc-btn');
      if (atcBtn) { handleAtcClick(atcBtn); }
    });
    /* Fetch cart → fetch recommendations → render */
    function load() {
      fetch('/cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          if (!cart.items || cart.items.length === 0) {
            root.style.display = 'none';
            lastProductId = null;
            return null;
          }
          return cart.items[0].product_id;
        })
        .then(function (productId) {
          if (!productId) return null;
          // Same product, slider already showing — keep it visible.
          if (productId === lastProductId) return 'skip';
          lastProductId = productId;
          // ATC click already fired the fetch — reuse it, zero extra latency.
          if (prefetchCache.productId === productId && prefetchCache.promise) {
            return prefetchCache.promise;
          }
          // No pre-fetch available (e.g. page-load initial run) — fetch now in parallel.
          return fetchRecs(productId, limit, intent);
        })
        .then(function (products) {
          if (products === 'skip') return; // same product, slider already visible
          if (!products || products.length === 0) {
            root.style.display = 'none';
            return;
          }
          render(products);
        })
        .catch(function (err) {
          console.warn('[cart-recs-slider]', err);
        });
    }
    /* Initial load */
    load();
    /* On ATC click: pre-fetch is already in flight from the outer listener.
  Consume it directly — no /cart.js call, no delay, renders instantly. */
    document.addEventListener(
      'click',
      function (e) {
        var btn = e.target.closest('[data-add-to-cart]');
        if (!btn) return;
        var form = btn.closest('form');
        if (!form) return;
        var pidInput = form.querySelector('input[name="product-id"]');
        if (!pidInput) return;
        var productId = parseInt(pidInput.value, 10);
        if (!productId || !prefetchCache.promise) return;
        lastProductId = productId;
        prefetchCache.promise
          .then(function (products) {
            if (!products || products.length === 0) {
              root.style.display = 'none';
              return;
            }
            render(products);
          })
          .catch(function (err) {
            console.warn('[cart-recs-slider]', err);
          });
      },
      true
    );
  } // end CartRecsSlider
  /* Run after DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', CartRecsSlider);
  } else {
    CartRecsSlider();
  }
})();

